export default __webpack_public_path__ + "static/media/img5.c96743a3.png";